import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoginService } from "../../../services/LoginService";
import * as FakeToken from "../../../constants/FakeToken";
import AuthContext from "../../../contexts/auth";
import { getConfig } from "../../../helpers/config";

export default function Login(props) {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const loginService = new LoginService();
  const environment = getConfig();

  useEffect(() => {
    if (environment?.profile !== "dev") {
      //const search = location.search;
      const search = window.location.search;
      const token = sessionStorage.getItem("access_token");
      if (!search && !token) {
        login();
      }
    }
  }, []);

  async function login() {
    const url = await loginService.getLoginUrl();
    window.location = url;
  }

  async function getToken(code, state) {
    try {
      code && console.log("got arpa code: " + code);
      const myState = sessionStorage.getItem("state");
      sessionStorage.removeItem("state");
      if (state !== myState) {
        return;
      }

      if (code) {
        loginService
          .login(code)
          .then((response) => response.json())
          .then(async (json) => {
            const token = json.access_token;
            const refreshToken = json.refresh_token;
            loginService
              .getUserInfo(token)
              .then((data) => data.json())
              .then(async (userInfo) => {
                const resp = await authContext.login(
                  token,
                  refreshToken,
                  userInfo
                );
                if (resp) {
                  navigate("/");
                }
              })
              .catch((error) => {
                props.toastContext.error("Errore");
              });
          })
          .catch((error) => {
            console.log(error);
            props.toastContext.error("Errore");
          });
      }
    } catch (error) {
      console.log(`errore: ${error}`);
      throw new Error("Errore getToken");
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    code && getToken(code, state);
  }, [window.location.search]);

  /** Login per ambiente DEV */
  const devLogin = (userType) => {
    authContext.resetParams(false);
    return async (e) => {
      const tokenForUser = FakeToken.devGetTokenByUserType(userType);
      const userInfo = FakeToken.devGetUserInfoByUserType(userType);
      const token = await authContext.baseLogin(tokenForUser, userInfo);
      if (token) {
        navigate('/', { state: '' });
      }
    };
  };

  return (
    <>
      {
        environment?.profile === "dev" &&
        <div className="rtds-container rtds-mx-auto rtds-my-12">
          <div className="rtds-flex rtds-justify-center ">
            <div className="rtds-w-full md:rtds-w-1/2">
              <button
                type="button"
                className="rtds-w-full rtds-mb-1 rtds-justify-center rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                onClick={devLogin("cittadino")}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-left-on-rectangle`}
                  />
                </svg>{" "}
                Accesso cittadino
              </button>
              <button
                type="button"
                className="rtds-w-full rtds-mb-1 rtds-justify-center rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                onClick={devLogin("ente")}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-left-on-rectangle`}
                  />
                </svg>{" "}
                Accesso oper. comunale
              </button>
              <button
                type="button"
                className="rtds-w-full rtds-mb-1 rtds-justify-center rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                onClick={devLogin("regione")}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-left-on-rectangle`}
                  />
                </svg>{" "}
                Accesso operatore regionale
              </button>
              <button
                type="button"
                className="rtds-w-full rtds-mb-1 rtds-justify-center rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                onClick={devLogin("admin")}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-left-on-rectangle`}
                  />
                </svg>{" "}
                Accesso admin
              </button>
            </div>
          </div>
        </div>
      }
    </>
  );
}
